<div class="page-tab">
  <div class="page-tab__dividers">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="page-tab__buttons">
    <button class="page-tab__button" (click)="changeToAirtScansTab()" [class.active]="scanActive()">
      {{ "Tabs.Scan" | translate }}
    </button>
    <button class="page-tab__button" (click)="changeToDdosFilterTab()" [class.active]="ddosActive()">
      {{ "Tabs.DDOS" | translate }}
    </button>
    <button class="page-tab__button" (click)="changeToDnsFirewallTab()" [class.active]="dnsFirewallActive()">
      {{ "Tabs.DNSFirewall" | translate }}
    </button>
  </div>
</div>
